/**
 * Synchronous, framework-independent capture of ad click IDs / UTMs.
 *
 * This string is injected as an inline <script> in the document <head> so it
 * executes BEFORE React hydration, the router, GTM/Zaraz or any consent tool.
 * It writes the same localStorage key + cookie that src/lib/utm-tracking.ts
 * reads, so nothing is lost if client-side routing or a trailing-slash
 * normalisation rewrites the URL later.
 */
export const UTM_INLINE_CAPTURE = `(function(){try{
var K=["utm_source","utm_medium","utm_campaign","utm_term","utm_content","utm_id","utm_creative","utm_adgroup","gclid","gclsrc","gad_source","gad_campaignid","gbraid","wbraid","kw","cpn","fbclid","msclkid","ttclid","li_fat_id","twclid"];
var S="restore_utm";
var p=new URLSearchParams(window.location.search);
var found={};
for(var i=0;i<K.length;i++){if(p.has(K[i])){found[K[i]]=p.get(K[i])||"";}}
if(!Object.keys(found).length)return;
var prev={};
try{var raw=window.localStorage.getItem(S);if(raw)prev=JSON.parse(raw)||{};}catch(e){}
var merged=Object.assign({},prev,found);
var val=JSON.stringify(merged);
try{window.localStorage.setItem(S,val);}catch(e){}
var d=window.location.hostname.indexOf("restorehair.com")>-1?"; domain=.restorehair.com":"";
document.cookie=S+"="+encodeURIComponent(val)+"; expires="+new Date(Date.now()+2592000000).toUTCString()+"; path=/; SameSite=Lax"+d;
}catch(e){}})();`;

/**
 * Bridge script served at /api/public/utm-bridge.js and included by the main
 * restorehair.com site. The `restore_utm` cookie is set on `.restorehair.com`
 * so it crosses subdomains, but localStorage does NOT. This rehydrates
 * localStorage on whatever host it runs on, merging (in priority order):
 * stored values < cookie < current URL params.
 */
export const UTM_BRIDGE_SCRIPT = `(function(){try{
var K=["utm_source","utm_medium","utm_campaign","utm_term","utm_content","utm_id","utm_creative","utm_adgroup","gclid","gclsrc","gad_source","gad_campaignid","gbraid","wbraid","kw","cpn","fbclid","msclkid","ttclid","li_fat_id","twclid"];
var S="restore_utm";
function parse(v){try{return JSON.parse(v)||{};}catch(e){return {};}}
var stored={};
try{var raw=window.localStorage.getItem(S);if(raw)stored=parse(raw);}catch(e){}
var ck={};
var m=document.cookie.match(new RegExp("(?:^|; )"+S+"=([^;]*)"));
if(m){try{ck=parse(decodeURIComponent(m[1]));}catch(e){}}
var p=new URLSearchParams(window.location.search);
var url={};
for(var i=0;i<K.length;i++){if(p.has(K[i])){url[K[i]]=p.get(K[i])||"";}}
var merged={};
[stored,ck,url].forEach(function(o){for(var k in o){if(o[k]!=="" && o[k]!=null)merged[k]=o[k];}});
if(!Object.keys(merged).length)return;
var val=JSON.stringify(merged);
try{window.localStorage.setItem(S,val);}catch(e){}
var d=window.location.hostname.indexOf("restorehair.com")>-1?"; domain=.restorehair.com":"";
document.cookie=S+"="+encodeURIComponent(val)+"; expires="+new Date(Date.now()+2592000000).toUTCString()+"; path=/; SameSite=Lax"+d;
try{window.RESTORE_UTM=merged;}catch(e){}
}catch(e){}})();`;